// import React, { useState } from "react";
// import axios from "../../api/axiosInstance";
// import toast from "react-hot-toast";
// import assistedImage from "../../assets/membershipimg.png";

// const ContactUsForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone_number: "",
//     enquiry: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       setSubmitting(true);
//       await axios.post("/api/contact-us/", form, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       toast.success("Your enquiry has been submitted!");
//       setForm({
//         name: "",
//         email: "",
//         phone_number: "",
//         enquiry: "",
//       });
//     } catch (error) {
//       console.error("Error Response:", error.response?.data || error.message);
//       toast.error(
//         error.response?.data?.detail ||
//           JSON.stringify(error.response?.data) ||
//           "Failed to submit. Please try again."
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="w-full mx-auto px-6 py-12">
//       <div className="grid md:grid-cols-2 gap-10 items-center bg-white shadow-lg rounded-3xl overflow-hidden">
//         {/* Left Image Section */}
//         <div className="w-full h-full flex justify-center items-center bg-green-50 p-6">
//           <img
//             src={assistedImage}
//             alt="Assisted Service"
//             className="rounded-2xl  w-full max-w-sm object-contain"
//           />
//         </div>

//         {/* Right Form Section */}
//         <div className="p-8 md:p-12">
//           <h2 className="text-3xl font-bold text-green-700 mb-2 text-center md:text-left">
//             📩 Send Your Enquiry
//           </h2>
//           <p className="text-gray-600 text-center md:text-left mb-8">
//             Fill out the form below and we will get back to you soon.
//           </p>

//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div className="grid md:grid-cols-2 gap-4">
//               {[
//                 {
//                   label: "Name *",
//                   name: "name",
//                   type: "text",
//                   placeholder: "Enter your name",
//                   required: true,
//                 },
//                 {
//                   label: "Email *",
//                   name: "email",
//                   type: "email",
//                   placeholder: "Enter your email",
//                   required: true,
//                 },
//                 {
//                   label: "Phone Number *",
//                   name: "phone_number",
//                   type: "text",
//                   placeholder: "Enter your phone number",
//                   required: true,
//                 },
//               ].map((field) => (
//                 <div key={field.name}>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     {field.label}
//                   </label>
//                   <input
//                     type={field.type}
//                     name={field.name}
//                     placeholder={field.placeholder}
//                     value={form[field.name]}
//                     onChange={handleChange}
//                     required={field.required}
//                     className={`w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-green-400 focus:outline-none ${
//                       errors[field.name] ? "border-red-500" : "border-gray-300"
//                     }`}
//                   />
//                   {errors[field.name] && (
//                     <p className="text-sm text-red-600 mt-1">
//                       {errors[field.name]}
//                     </p>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* Enquiry Field */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Your Enquiry *
//               </label>
//               <textarea
//                 name="enquiry"
//                 value={form.enquiry}
//                 onChange={handleChange}
//                 required
//                 rows={5}
//                 placeholder="Write your enquiry here..."
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-green-400 focus:outline-none"
//               ></textarea>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={submitting}
//               className={`w-full bg-green-600 text-white font-semibold py-3 rounded-lg shadow-md transition hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 ${
//                 submitting ? "opacity-50 cursor-not-allowed" : ""
//               }`}
//             >
//               {submitting ? "Submitting..." : "Submit Enquiry"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUsForm;
// src/components/ContactUsForm.jsx

import React, { useState, useEffect } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";

/* ─── CSS ─────────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jbcf {
  width: 100%;
  padding: clamp(24px, 4vw, 56px) clamp(12px, 4vw, 32px);
  font-family: 'Inter', sans-serif;
  background: linear-gradient(160deg, #1A0505 0%, #3D0A0A 55%, #5A1010 100%);
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* dot-grid */
.jbcf-dust {
  position: fixed; inset: 0; pointer-events: none; z-index: 0;
  background-image: radial-gradient(circle, rgba(201,150,42,0.10) 1px, transparent 1px);
  background-size: 36px 36px;
}

/* ── card ── */
.jbcf-card {
  position: relative; z-index: 1;
  max-width: 980px; margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(0,0,0,0.55);
  border: 1px solid rgba(201,150,42,0.25);
}

/* gold top bar */
.jbcf-card::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, transparent, #C9962A 30%, #E8C46A 50%, #C9962A 70%, transparent);
  z-index: 3;
}

/* ── LEFT PANEL ── */
.jbcf-left {
  background: linear-gradient(160deg, #5A1010 0%, #3D0A0A 100%);
  padding: clamp(32px, 4vw, 52px) clamp(24px, 3.5vw, 40px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: clamp(16px, 2.5vw, 24px);
  position: relative;
  overflow: hidden;
}

/* spinning mandala watermark */
.jbcf-mandala {
  position: absolute;
  bottom: -60px; right: -60px;
  width: 260px; height: 260px;
  opacity: 0.06;
  animation: jbcfSpin 80s linear infinite;
  pointer-events: none;
}
@keyframes jbcfSpin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .jbcf-mandala { animation: none; } }

.jbcf-om {
  font-size: clamp(38px, 5vw, 54px);
  color: #C9962A;
  font-family: serif;
  line-height: 1;
  filter: drop-shadow(0 0 12px rgba(201,150,42,0.35));
}

.jbcf-brand-name {
  font-family: 'Playfair Display', serif;
  font-size: clamp(18px, 2.2vw, 24px);
  font-weight: 700;
  color: #FDF6EC;
  line-height: 1.25;
}
.jbcf-brand-tag {
  font-size: clamp(9px, 1vw, 11px);
  color: #C9962A;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 2px;
}

.jbcf-divrow {
  display: flex; align-items: center; gap: 10px; width: 100%;
}
.jbcf-divline { flex: 1; height: 1px; background: rgba(201,150,42,0.35); }
.jbcf-divsym  { color: #C9962A; font-size: 15px; }

.jbcf-left-body {
  font-size: clamp(12.5px, 1.3vw, 14px);
  color: rgba(253,246,236,0.75);
  line-height: 1.75;
}

.jbcf-pills {
  list-style: none; display: flex; flex-direction: column; gap: 10px; width: 100%;
}
.jbcf-pill {
  display: flex; align-items: flex-start; gap: 10px;
  background: rgba(201,150,42,0.07);
  border: 1px solid rgba(201,150,42,0.2);
  border-radius: 10px;
  padding: 11px 14px;
}
.jbcf-pill-icon {
  color: #C9962A; font-size: 16px; flex-shrink: 0; margin-top: 1px;
}
.jbcf-pill-text {
  font-size: clamp(11.5px, 1.2vw, 13px);
  color: rgba(253,246,236,0.8);
  line-height: 1.5;
}
.jbcf-pill-label {
  font-family: 'Playfair Display', serif;
  font-size: clamp(12px, 1.3vw, 13.5px);
  font-weight: 700; color: #FDF6EC; margin-bottom: 2px;
}

/* ── RIGHT PANEL (FORM) ── */
.jbcf-right {
  background: #FDF6EC;
  padding: clamp(28px, 4vw, 48px) clamp(24px, 3.5vw, 44px);
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2vw, 22px);
}

.jbcf-form-head { text-align: left; }
.jbcf-form-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(20px, 2.5vw, 28px);
  font-weight: 700; color: #7B1C1C;
  margin-bottom: 6px;
}
.jbcf-form-title em { font-style: italic; color: #A87820; }
.jbcf-form-sub {
  font-size: clamp(12px, 1.2vw, 13.5px);
  color: #8B7355; line-height: 1.6;
}

/* lotus divider */
.jbcf-lotus-row { display: flex; align-items: center; gap: 10px; }
.jbcf-lotus-line { flex: 1; height: 1px; background: rgba(201,150,42,0.35); }

/* field grid */
.jbcf-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.jbcf-field-full { grid-column: 1 / -1; }

.jbcf-label {
  display: block;
  font-size: 12px; font-weight: 600;
  color: #5A1010; letter-spacing: 0.4px;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.jbcf-input, .jbcf-textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #D9C8A8;
  border-radius: 8px;
  font-size: clamp(12.5px, 1.3vw, 14px);
  color: #2C1A0E;
  background: #fff;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
  -webkit-appearance: none;
  appearance: none;
}
.jbcf-input:focus, .jbcf-textarea:focus {
  border-color: #C9962A;
  box-shadow: 0 0 0 3px rgba(201,150,42,0.12);
}
.jbcf-input.has-error, .jbcf-textarea.has-error {
  border-color: #C0392B;
}
.jbcf-textarea { resize: vertical; min-height: 110px; }

.jbcf-err { font-size: 11px; color: #C0392B; margin-top: 3px; }

/* submit button */
.jbcf-btn {
  width: 100%;
  padding: clamp(11px, 1.5vw, 14px);
  background: linear-gradient(90deg, #7B1C1C, #5A1010);
  border: 1.5px solid #C9962A;
  border-radius: 8px;
  color: #FDF6EC;
  font-size: clamp(13.5px, 1.5vw, 15px);
  font-weight: 700;
  font-family: 'Playfair Display', serif;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: opacity 0.18s, transform 0.15s;
}
.jbcf-btn:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
.jbcf-btn:disabled { opacity: 0.55; cursor: not-allowed; }

.jbcf-tos {
  font-size: 11px; color: #8B7355; text-align: center;
}
.jbcf-tos a { color: #7B1C1C; text-decoration: underline; }

/* ══════════════════
   RESPONSIVE
══════════════════ */

/* Tablet → stack panels */
@media (max-width: 820px) {
  .jbcf-card { grid-template-columns: 1fr; }
  .jbcf-left {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px;
    padding: 24px 20px;
  }
  .jbcf-om { font-size: 32px; }
  .jbcf-pills { display: none; }
  .jbcf-left-body { display: none; }
  .jbcf-mandala { display: none; }
  .jbcf-divrow { display: none; }
}

/* Mobile → single-col fields */
@media (max-width: 560px) {
  .jbcf-fields { grid-template-columns: 1fr; }
  .jbcf-field-full { grid-column: 1; }
  .jbcf-right { padding: 24px 18px; }
}

@media (max-width: 360px) {
  .jbcf { padding: 0; }
  .jbcf-card { border-radius: 0; box-shadow: none; }
}
`;

/* ─── Mandala SVG ─────────────────────────────────────────────────────────── */
const Mandala = () => (
  <svg
    className="jbcf-mandala"
    viewBox="0 0 400 400"
    fill="none"
    aria-hidden="true"
  >
    {[30, 65, 100, 135, 165, 190].map((r, i) => (
      <circle
        key={i}
        cx="200"
        cy="200"
        r={r}
        stroke="#C9962A"
        strokeWidth={i === 5 ? 1.5 : 0.8}
        strokeDasharray={i === 1 ? "4 4" : undefined}
      />
    ))}
    {Array.from({ length: 16 }, (_, i) => {
      const a = i * 22.5 * (Math.PI / 180);
      const x = 200 + 100 * Math.cos(a),
        y = 200 + 100 * Math.sin(a);
      const cx1 = 200 + 138 * Math.cos(a + 0.18),
        cy1 = 200 + 138 * Math.sin(a + 0.18);
      const cx2 = 200 + 138 * Math.cos(a - 0.18),
        cy2 = 200 + 138 * Math.sin(a - 0.18);
      return (
        <path
          key={i}
          d={`M200,200 Q${cx1},${cy1} ${x},${y} Q${cx2},${cy2} 200,200`}
          stroke="#C9962A"
          strokeWidth="0.7"
        />
      );
    })}
    {Array.from({ length: 12 }, (_, i) => {
      const a = i * 30 * (Math.PI / 180);
      return (
        <line
          key={i}
          x1={200 + 22 * Math.cos(a)}
          y1={200 + 22 * Math.sin(a)}
          x2={200 + 65 * Math.cos(a)}
          y2={200 + 65 * Math.sin(a)}
          stroke="#C9962A"
          strokeWidth="0.8"
        />
      );
    })}
    <circle cx="200" cy="200" r="22" stroke="#C9962A" strokeWidth="1" />
  </svg>
);

/* ─── Lotus divider ──────────────────────────────────────────────────────── */
const Lotus = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden="true"
  >
    <ellipse cx="14" cy="16" rx="4" ry="9" fill="#C9962A" opacity=".9" />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(-30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(-58 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(58 14 16)"
    />
    <ellipse cx="14" cy="24" rx="7" ry="2.5" fill="#C9962A" opacity=".25" />
  </svg>
);

/* ─── Left panel info pills ──────────────────────────────────────────────── */
const pills = [
  {
    icon: "🪷",
    label: "Dharmic Guidance",
    text: "Our relationship managers are rooted in Jain values and traditions.",
  },
  {
    icon: "☸",
    label: "Quick Response",
    text: "We respond within 24 hours — on every working day.",
  },
  {
    icon: "🔒",
    label: "Complete Privacy",
    text: "Your enquiry is handled with full confidentiality and respect.",
  },
];

/* ─── Component ───────────────────────────────────────────────────────────── */
const ContactUsForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone_number: "",
    enquiry: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [focused, setFocused] = useState(null);

  useEffect(() => {
    const id = "jbcf-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await axios.post("/api/contact-us/", form, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success(
        "Your enquiry has been submitted! We'll reach out soon. 🪷",
      );
      setForm({ name: "", email: "", phone_number: "", enquiry: "" });
    } catch (error) {
      toast.error(
        error.response?.data?.detail || "Failed to submit. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  const ic = (name) =>
    ["jbcf-input", errors[name] ? "has-error" : ""].filter(Boolean).join(" ");

  return (
    <div className="jbcf">
      <div className="jbcf-dust" aria-hidden="true" />

      <div className="jbcf-card">
        {/* ── LEFT ── */}
        <div className="jbcf-left">
          <Mandala />

          <span className="jbcf-om" aria-label="Om">
            ꣽ
          </span>

          <div>
            <div className="jbcf-brand-name">Jain Var Vadhu</div>
            <div className="jbcf-brand-tag">Divine Values · Sacred Bond</div>
          </div>

          <div className="jbcf-divrow" aria-hidden="true">
            <div className="jbcf-divline" />
            <span className="jbcf-divsym">☸</span>
            <div className="jbcf-divline" />
          </div>

          <p className="jbcf-left-body">
            We're here to guide your sacred journey. Share your enquiry with us
            and our Dharma-rooted relationship managers will respond with care
            and complete confidentiality.
          </p>

          <ul className="jbcf-pills" aria-label="Why reach out">
            {pills.map(({ icon, label, text }) => (
              <li key={label} className="jbcf-pill">
                <span className="jbcf-pill-icon" aria-hidden="true">
                  {icon}
                </span>
                <div>
                  <div className="jbcf-pill-label">{label}</div>
                  <div className="jbcf-pill-text">{text}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* ── RIGHT (FORM) ── */}
        <div className="jbcf-right">
          <div className="jbcf-form-head">
            <h2 className="jbcf-form-title">
              Send Your <em>Enquiry</em>
            </h2>
            <p className="jbcf-form-sub">
              Fill in the details below and we will connect you with your sacred
              match journey.
            </p>
          </div>

          <div className="jbcf-lotus-row" aria-hidden="true">
            <div className="jbcf-lotus-line" />
            <Lotus />
            <div className="jbcf-lotus-line" />
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="jbcf-fields">
              {/* Name */}
              <div>
                <label className="jbcf-label" htmlFor="jb-name">
                  Full Name *
                </label>
                <input
                  id="jb-name"
                  className={ic("name")}
                  type="text"
                  name="name"
                  placeholder="Your full name"
                  value={form.name}
                  onChange={handleChange}
                  onFocus={() => setFocused("name")}
                  onBlur={() => setFocused(null)}
                  autoComplete="name"
                  required
                />
                {errors.name && <p className="jbcf-err">{errors.name}</p>}
              </div>

              {/* Email */}
              <div>
                <label className="jbcf-label" htmlFor="jb-email">
                  Email Address *
                </label>
                <input
                  id="jb-email"
                  className={ic("email")}
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  value={form.email}
                  onChange={handleChange}
                  onFocus={() => setFocused("email")}
                  onBlur={() => setFocused(null)}
                  autoComplete="email"
                  inputMode="email"
                  required
                />
                {errors.email && <p className="jbcf-err">{errors.email}</p>}
              </div>

              {/* Phone */}
              <div>
                <label className="jbcf-label" htmlFor="jb-phone">
                  Phone Number *
                </label>
                <input
                  id="jb-phone"
                  className={ic("phone_number")}
                  type="tel"
                  name="phone_number"
                  placeholder="+91 00000 00000"
                  value={form.phone_number}
                  onChange={handleChange}
                  onFocus={() => setFocused("phone_number")}
                  onBlur={() => setFocused(null)}
                  autoComplete="tel"
                  inputMode="tel"
                  required
                />
                {errors.phone_number && (
                  <p className="jbcf-err">{errors.phone_number}</p>
                )}
              </div>

              {/* Enquiry */}
              <div className="jbcf-field-full">
                <label className="jbcf-label" htmlFor="jb-enquiry">
                  Your Enquiry *
                </label>
                <textarea
                  id="jb-enquiry"
                  className={[
                    "jbcf-textarea",
                    errors.enquiry ? "has-error" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  name="enquiry"
                  placeholder="Share your thoughts, questions, or how we can help you begin your sacred journey…"
                  value={form.enquiry}
                  onChange={handleChange}
                  onFocus={() => setFocused("enquiry")}
                  onBlur={() => setFocused(null)}
                  required
                />
                {errors.enquiry && <p className="jbcf-err">{errors.enquiry}</p>}
              </div>
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="jbcf-btn"
              style={{ marginTop: 14 }}
            >
              {submitting ? "Submitting…" : "🪷 Submit Enquiry"}
            </button>
          </form>

          <p className="jbcf-tos">
            By submitting, you agree to our{" "}
            <a href="/terms-and-conditions" target="_blank" rel="noreferrer">
              Terms &amp; Conditions
            </a>{" "}
            and{" "}
            <a href="/privacy-policy" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUsForm;
